import React, { useContext, useState } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  Checkbox,
  ListItemText,
  Button,
  Typography,
} from "@mui/material";
import ReportIcon from "@mui/icons-material/Report";
import { UserContext } from "../contexts/userContext";

export default function ErrorReporter({ apiEndpoint, report_id }) {
  const userContext = useContext(UserContext);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedErrors, setSelectedErrors] = useState([]);
  const open = Boolean(anchorEl);

  const errorOptions = [
    { id: 1, label: "Incorrect Information" },
    { id: 2, label: "Broken Link" },
    { id: 3, label: "Outdated Content" },
    { id: 4, label: "Spelling/Grammar Issue" },
    { id: 5, label: "Other" },
  ];

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCheckboxChange = (id) => {
    setSelectedErrors((prev) =>
      prev.includes(id) ? prev.filter((errorId) => errorId !== id) : [...prev, id]
    );
  };

  const handleSubmit = () => {
    const selectedErrorLabels = errorOptions
      .filter((option) => selectedErrors.includes(option.id))
      .map((option) => option.label);

    apiEndpoint(report_id, selectedErrorLabels, userContext.user )
      .then((response) => {
        if (response.ok) {
          alert("Thank you for reporting the issue!");
        } else {
          alert("Ooops, looks like something went wrong. Please try again.");
        }
      })
      .catch(() => {
        alert("Ooops, looks like something went wrong. Please try again.");
      });

    // Reset state and close menu
    setSelectedErrors([]);
    handleClose();
  };

  return (
    <>
      <IconButton onClick={handleClick} aria-label="report error">
        <ReportIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: { padding: "16px", width: "250px" },
        }}
      >
        <Typography variant="h6" align="center" gutterBottom>
          Report an Issue
        </Typography>
        {errorOptions.map((option) => (
          <MenuItem key={option.id} onClick={() => handleCheckboxChange(option.id)}>
            <Checkbox checked={selectedErrors.includes(option.id)} />
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
        <div style={{ display: "flex", justifyContent: "center", marginTop: "8px" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={selectedErrors.length === 0}
          >
            Submit
          </Button>
        </div>
      </Menu>
    </>
  );
}